import { NodeEdge } from "@hex-insights/app-modules";
import {
	mergeFilterInputs,
	User,
	UserFilterInput,
	UserGroup,
	UserGroupFilterInput,
	UserNameDescriptionAndImageFragment,
	UserStatus,
	useUserAndUserGroupListForMessagesQuery,
	useUserListForMessagesQuery,
} from "../../../../../Utilities";

export type MessagingUser = Pick<User, "id"> & UserNameDescriptionAndImageFragment;

const nondisabledUserFilter: UserFilterInput = {
	statusNEQ: UserStatus.Disabled,
};

const populatedUserGroupFilter: UserGroupFilterInput = {
	members: [nondisabledUserFilter],
};

export function useUserRecipients(filters?: UserFilterInput) {
	return useUserListForMessagesQuery({
		variables: { filters: filters ? mergeFilterInputs(filters, nondisabledUserFilter) : nondisabledUserFilter },
	});
}

export function useUserAndUserGroupRecipients(
	search: string | null | undefined,
	userFilter?: UserFilterInput,
	userGroupFilter?: UserGroupFilterInput,
) {
	const fullUserFilter: UserFilterInput = { search };
	if (userFilter) {
		fullUserFilter.and = [userFilter, nondisabledUserFilter];
	} else {
		fullUserFilter.and = [nondisabledUserFilter];
	}

	const fullUserGroupFilter: UserGroupFilterInput = { search };
	if (userGroupFilter) {
		fullUserGroupFilter.and = [userGroupFilter, populatedUserGroupFilter];
	} else {
		fullUserGroupFilter.and = [populatedUserGroupFilter];
	}

	return useUserAndUserGroupListForMessagesQuery({
		variables: {
			userFilters: fullUserFilter,
			userGroupFilters: fullUserGroupFilter,
		},
	});
}

export function splitUserGroups<T extends Pick<UserGroup, "id"> & { members: Pick<User, "id" | "isCurrent">[] }>(
	userGroupsData: { userGroupConnection: { edges: NodeEdge<T>[] } } | null | undefined,
) {
	const viewerGroups: T[] = [];
	const otherGroups: T[] = [];

	if (!userGroupsData) {
		return { viewerGroups, otherGroups };
	}

	for (let i = 0; i < userGroupsData.userGroupConnection.edges.length; i++) {
		const userGroup = userGroupsData.userGroupConnection.edges[i].node;
		if (userGroup.members.some((member) => member.isCurrent)) {
			viewerGroups.push(userGroup);
		} else {
			otherGroups.push(userGroup);
		}
	}

	return { viewerGroups, otherGroups };
}
